import { SignJWT } from "jose";

const createJWT = async (userInfo) => {
  const secretKey = new TextEncoder().encode(
    "G2aOwM6ogp4inpqOje1UrqDRVJlhb6JH3il2HMo7gETHvuzrdEsQiemn3a_nJFFjJ6iqWX0YXupKZi--6b14jA",
  );

  const jwt = await new SignJWT(userInfo)
    .setProtectedHeader({ alg: "HS256", kid: "app_66f2af92d9f2380d655b0048" })
    .setIssuedAt()
    .setExpirationTime("300s")
    .sign(secretKey);
  return jwt;
};

export default createJWT;
